// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientBlock_root__G9s-6","header":"PatientBlock_header__3WrWM","label":"PatientBlock_label__1-zaW","option":"PatientBlock_option__30cLS"};